import React from 'react';
import { type IAppContextShape } from '../../types/appConfigTypes';

export const AppConfigContext = React.createContext<IAppContextShape | null>(null);

export default AppConfigContext;
